import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import '../../talukas/create/css/talukaCreate.css';

function TenderFormModal({ open, onClose, initial = {}, onSave }) {
  const [form, setForm] = useState({ refNo: '', publishDate: '', closingDate: '', description: '', status:'' });

  useEffect(() => {
    if (initial) {
      setForm({
        refNo: initial.refNo || '',
        publishDate: initial.publishDate || '',
        closingDate: initial.closingDate || '',
        description: initial.description || '',
        status: initial.status || 'DRAFT',
      });
    }
  }, [initial]);

  const change = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  };

  const submit = e => {
    e.preventDefault();
    onSave(form);
  };

  if (!open) return null;

  return (
    <div className="eduss-global-modal-overlay" onClick={onClose}>
      <div className="eduss-global-modal eduss-admin-form-modal" onClick={e => e.stopPropagation()}>
        <div className="eduss-global-modal-header">
          <h3>{initial?.id ? 'Edit Tender' : 'Create Tender'}</h3>
          <button onClick={onClose}>×</button>
        </div>
        <form onSubmit={submit} className="eduss-taluka-create-form" style={{ padding: '16px 8px' }}>
          <div className="eduss-taluka-create-field">
            <label>Reference No *</label>
            <input name="refNo" value={form.refNo} onChange={change} required />
          </div>
          <div className="eduss-taluka-create-field">
            <label>Publish Date</label>
            <input type="date" name="publishDate" value={form.publishDate} onChange={change} />
          </div>
          <div className="eduss-taluka-create-field">
            <label>Closing Date</label>
            <input type="date" name="closingDate" value={form.closingDate} onChange={change} />
          </div>
          <div className="eduss-taluka-create-field">
            <label>Description</label>
            <textarea name="description" value={form.description} onChange={change} />
          </div>

          {initial?.id && (
          <div className="eduss-taluka-create-field">
            <label>Status</label>
            <select name="status" value={form.status} onChange={change}>
              <option value="DRAFT">DRAFT</option>
              <option value="PUBLISHED">PUBLISHED</option>
              <option value="CLOSED">CLOSED</option>
            </select>
          </div>) }

          <div className="eduss-student-create-actions" style={{ marginTop: 24 }}>
            <button type="button" className="eduss-student-create-btn cancel" onClick={onClose}>Cancel</button>
            <button type="submit" className="eduss-student-create-btn submit">Save</button>
          </div>
        </form>
      </div>
    </div>
  );
}

TenderFormModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  initial: PropTypes.object,
  onSave: PropTypes.func,
};

export default TenderFormModal;
